import FormikControl from '../../../../components/formikControl/FormikControl'
import {useChatContext} from '../Context'

function ClassDivsion() {
  const {data} = useChatContext()
  const {classes, divisions} = data
  return (
    <div className="d-flex gap-2">
      <FormikControl
        control={'select-advanced'}
        options={classes}
        name="class_Name"
        placeholder="Select"
        optionLabel={'class_name'}
        optionValue={'class_name'}
        label="Class"
        className="w-50"
        size="sm"
      />
      <FormikControl
        control={'select-advanced'}
        options={divisions}
        name="divisionName"
        placeholder="Select"
        optionLabel={'division_name'}
        optionValue={'division_name'}
        label="Division"
        className="w-50"
        size="sm"
      />
    </div>
  )
}

export default ClassDivsion
